// Typing inside a shared work session. Channel typing is only kept for the channel
// that is open, and the session page is not that channel, so it needs its own store.
class WorkSessionTypingState {
  bySession = $state<Record<string, { fromId: string; fromName: string | null }[]>>({});
  #timers = new Map<string, ReturnType<typeof setTimeout>>();

  add(event: { workSessionId?: string; fromId: string; fromName?: string | null }): void {
    const id = event.workSessionId;
    if (!id) return;
    const key = `${id}:${event.fromId}`;
    const prev = this.#timers.get(key);
    if (prev) clearTimeout(prev);
    const rows = (this.bySession[id] ?? []).filter((r) => r.fromId !== event.fromId);
    this.bySession = {
      ...this.bySession,
      [id]: [...rows, { fromId: event.fromId, fromName: event.fromName ?? null }],
    };
    this.#timers.set(
      key,
      setTimeout(() => {
        this.#timers.delete(key);
        const left = (this.bySession[id] ?? []).filter((r) => r.fromId !== event.fromId);
        this.bySession = { ...this.bySession, [id]: left };
      }, 5000),
    );
  }

  names(workSessionId: string | null | undefined): string[] {
    if (!workSessionId) return [];
    return (this.bySession[workSessionId] ?? []).map((r) => r.fromName ?? "Someone");
  }
}
export const workSessionTypingState = new WorkSessionTypingState();
